import React, { useState } from 'react';

export default function TextStubCard({ values = [], count }) {
  const [showRaw, setShowRaw] = useState(false);
  const responseCount = count != null ? count : values.length;

  const toggleRaw = () => setShowRaw(!showRaw);

  const infoCardStyle = {
    background: '#FFF9E6',
    border: '1px solid #F5E5B3',
    color: '#7A6A3A',
    borderRadius: '8px',
    padding: '16px',
    fontFamily: 'var(--font-family-primary)',
    marginBottom: '16px'
  };

  const buttonRowStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
    fontFamily: 'var(--font-family-primary)'
  };

  const disabledButtonStyle = {
    background: '#F1F3F4',
    color: '#9AA0A6',
    border: '1px solid #E8EAED',
    borderRadius: '4px',
    padding: '6px 12px',
    cursor: 'not-allowed'
  };

  const enabledButtonStyle = {
    background: '#FFFFFF',
    color: '#3C4043',
    border: '1px solid #DADCE0',
    borderRadius: '4px',
    padding: '6px 12px',
    cursor: 'pointer'
  };

  const tableContainerStyle = {
    maxHeight: '360px',
    overflow: 'auto',
    fontFamily: 'var(--font-family-primary)'
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse'
  };

  const thStyle = {
    border: '1px solid #E8EAED',
    padding: '8px',
    textAlign: 'left'
  };

  const tdStyle = {
    border: '1px solid #E8EAED',
    padding: '8px'
  };

  return (
    <div>
      <div style={infoCardStyle}>
        <h3 style={{ margin: '0 0 6px' }}>{responseCount} free-text responses</h3>
        <p style={{ margin: 0 }}>Text classification isn't available yet. You can browse the raw responses now; categorize and synthesize arrive with the text-analysis work packages.</p>
      </div>

      <div style={buttonRowStyle}>
        <button style={disabledButtonStyle} title="Coming with text classification" disabled>
          Use authored categories
        </button>
        <button style={disabledButtonStyle} title="Coming with text synthesis" disabled>
          Synthesize categories
        </button>
        <button style={enabledButtonStyle} onClick={toggleRaw}>
          Browse raw
        </button>
      </div>

      {showRaw && (
        <div style={tableContainerStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Response</th>
              </tr>
            </thead>
            <tbody>
              {values.map((value, index) => (
                <tr key={index}>
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{String(value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
